module.exports = __webpack_public_path__ + "img/744.f971e781.jpg";